
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/productDetails",
      function () {
        return require("private-next-pages/productDetails/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/productDetails"])
      });
    }
  